var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointHoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "data_usage"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "data_usage_2",
    d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.9708 4.925 19.0625C4.025 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 9.38333 2.86667 7.13333 4.6 5.25C6.33333 3.36667 8.46667 2.3 11 2.05V5.05C9.28333 5.28333 7.85417 6.05417 6.7125 7.3625C5.57083 8.67083 5 10.2167 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 19 12 19C13.1 19 14.1292 18.7667 15.0875 18.3C16.0458 17.8333 16.85 17.2 17.5 16.4L20.1 17.9C19.2 19.15 18.0417 20.1458 16.625 20.8875C15.2083 21.6292 13.6667 22 12 22ZM21.15 16.05L18.55 14.55C18.7 14.15 18.8125 13.7375 18.8875 13.3125C18.9625 12.8875 19 12.45 19 12C19 10.2167 18.4292 8.67083 17.2875 7.3625C16.1458 6.05417 14.7167 5.28333 13 5.05V2.05C15.5333 2.3 17.6667 3.36667 19.4 5.25C21.1333 7.13333 22 9.38333 22 12C22 12.7333 21.9333 13.4417 21.8 14.125C21.6667 14.8083 21.45 15.45 21.15 16.05Z",
    fill: "#00B87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointHoldIcon);
export default __webpack_public_path__ + "static/media/PointHoldIcon.b9276d47831b4dbb13b6559f984b05cc.svg";
export { ForwardRef as ReactComponent };